/**
 * Aufgaben-Status wie in CRM 1.0: 0 = Offen, 2 = In Bearbeitung, 1 = Erledigt.
 * (Die Zahlenwerte sind historisch — „Erledigt" war zuerst da.)
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BRAND, BRAND_LIGHT, getThemeColors } from '../../../lib/theme';

export const TASK_STATUS_OPEN = 0;
export const TASK_STATUS_DONE = 1;
export const TASK_STATUS_IN_PROGRESS = 2;

/** Reihenfolge der Auswahl: Offen → In Bearbeitung → Erledigt. */
export const TASK_STATUS_OPTIONS: { value: number; labelKey: string }[] = [
  { value: TASK_STATUS_OPEN, labelKey: 'pflege.tasks.status.open' },
  { value: TASK_STATUS_IN_PROGRESS, labelKey: 'pflege.tasks.status.in_progress' },
  { value: TASK_STATUS_DONE, labelKey: 'pflege.tasks.status.done' },
];

/** Dreistufiger Status-Umschalter für Aufgaben-Formulare. */
export function TaskStatusSelect({ dark, value, onChange, compact = false }: {
  dark: boolean;
  value: number;
  onChange: (status: number) => void;
  compact?: boolean;
}) {
  const tc = getThemeColors(dark);
  const { t } = useTranslation();
  return (
    <div>
      <div style={{ fontSize: compact ? 11 : 12, fontWeight: compact ? 400 : 600, color: tc.muted, marginBottom: 5 }}>
        {t('pflege.tasks.status.label')}
      </div>
      <div role="radiogroup" aria-label={t('pflege.tasks.status.label')} style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {TASK_STATUS_OPTIONS.map(opt => {
          const active = value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              role="radio"
              aria-checked={active}
              data-testid={`task-status-${opt.value}`}
              onClick={() => onChange(opt.value)}
              style={{
                flex: 1, fontSize: compact ? 12 : 13, fontWeight: 600, padding: compact ? '5px 8px' : '8px 10px',
                borderRadius: 8, cursor: 'pointer', fontFamily: 'Outfit,sans-serif', whiteSpace: 'nowrap',
                border: `1px solid ${active ? BRAND : tc.border}`,
                background: active ? BRAND_LIGHT : tc.inputBg,
                color: active ? BRAND : tc.text,
              }}
            >
              {t(opt.labelKey)}
            </button>
          );
        })}
      </div>
    </div>
  );
}

/** Kleines Kennzeichen „In Bearbeitung" für Aufgaben-Zeilen (sonst nichts). */
export function TaskInProgressBadge({ status }: { status?: number | null }) {
  const { t } = useTranslation();
  if (status !== TASK_STATUS_IN_PROGRESS) return null;
  return (
    <span
      data-testid="task-in-progress"
      style={{
        fontSize: 10, fontWeight: 700, borderRadius: 999, padding: '1px 7px', flexShrink: 0,
        background: '#fef0c7', color: '#b54708', whiteSpace: 'nowrap',
      }}
    >
      {t('pflege.tasks.status.in_progress')}
    </span>
  );
}
